import * as React from "react";
import { forwardRef } from "react";
const SvgEmail = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 18, height: 18, viewBox: "0 0 18 18", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M0 2.7v12.462h18V2.7zm2.986 1.385h12.028L9 8.085Zm-1.6.606 7.226 4.825.389.238.389-.238 7.225-4.826v9.087H1.385Z", className: "sefa0f34575a2e3259cf62ddd9e386da4__b" }));
const ForwardRef = forwardRef(SvgEmail);
export { ForwardRef as ReactComponent };
